import React, { useState, useEffect } from "react";
import { Route } from "react-router-dom";
import { AuthConsumer } from "./AuthProvider";
import { LoadingModal } from "../modals"
import Consent from '@lms/react-consent';
import settingsService from '../../services/settingsService';
import UserService from './UserService';

const CheckAuthenticated = (props) => {
    const { isAuthenticated, signinRedirect } = props;
    const [signedIn, setSignedIn] = useState(false);
    const [consentServiceUrl, setConsentServiceUrl] = useState('');
    
    useEffect(() => {
        async function init() {
            isAuthenticated().then((result) => {
                setSignedIn(result);

                if (!result)
                    return signinRedirect();
            });
        }
        init();
        const domain = window.location.host;
        let configs = require('../../config.json');        
        const config = configs.filter(c => c.Domain.toLowerCase() === domain.toLowerCase())[0];
        setConsentServiceUrl(config.ConsentServiceUrl);
    });

    if (signedIn) {

        return <Consent loading={<LoadingModal isBusy={true} loadingText="Loading..." />} uri={consentServiceUrl} productId="2a7fb362-dc1b-4738-b3bc-e7e9a1e8b64b" getAccessToken={() => UserService.getAccessToken(settingsService.authConfig)}>
            {props.children}
        </Consent>
    }

    return <LoadingModal isBusy={true} loadingText="Loading..." />;

}

const PrivateRoute = ({ component, ...rest }) => {
    const renderFn = (Component) => (props) => (
        <AuthConsumer>
            {({ isAuthenticated, signinRedirect, getAccessToken }) => {
                return (
                    <CheckAuthenticated isAuthenticated={isAuthenticated} signinRedirect={signinRedirect}>

                        <Component getAccessToken={getAccessToken} {...props} />
                    </CheckAuthenticated>
                );
            }}
        </AuthConsumer>
    );

    return <Route {...rest} component={renderFn(component)} />;
};

export default PrivateRoute;